import { AddressFormFields } from '../Address.constants';

export const getAddressComponents = (
  place: google.maps.places.PlaceResult,
): {
  [AddressFormFields.Postcode]: string;
  [AddressFormFields.City]: string;
  [AddressFormFields.StreetLine1]: string;
} => {
  const getAddressComponent = (
    type: string,
  ): google.maps.GeocoderAddressComponent | undefined =>
    place?.address_components?.find((component) =>
      component.types.includes(type),
    );

  const streetComponent = getAddressComponent('route');
  const streetNumber = getAddressComponent('street_number')?.long_name || '';

  const isStreetNumberAfter = () => {
    /*
     * Street line formats might differ,
     * e.g. France: 20 Rue May, Germany: Flughafenstr. 1
     * Here we persist the localised formatting from API.
     */
    const fullAddress = place.formatted_address || '';
    const street = fullAddress.includes(streetComponent?.long_name || '')
      ? streetComponent?.long_name
      : streetComponent?.short_name;

    return (
      fullAddress.indexOf(street || '') < fullAddress.indexOf(streetNumber)
    );
  };

  const streetLine1 = isStreetNumberAfter()
    ? `${streetComponent?.long_name} ${streetNumber}`
    : `${streetNumber} ${streetComponent?.long_name}`;

  return {
    [AddressFormFields.Postcode]:
      getAddressComponent('postal_code')?.long_name || '',
    [AddressFormFields.City]: getAddressComponent('locality')?.long_name || '',
    // We allow the user to enter a manual address, for Google Places API is place.name
    [AddressFormFields.StreetLine1]: streetLine1?.includes('undefined')
      ? place.name
      : streetLine1,
  };
};

export const handleAutocompleteFailure = (): void => {
  const field = document.getElementById('address-line1') as HTMLInputElement;
  /*
   * Google Places autocomplete widget disables the text field
   * entirely upon failure of the API.
   *
   * Here we prevent this behaviour.
   */

  if (field) {
    field.disabled = false;
    field.placeholder = '';
    field.style.backgroundImage = '';
  }
};
